export default [
  // {en: 'Order', cs: 'Objednávka'},
  // {en: 'For whom we prepare Haffit', cs: 'Haffit připravujeme pro'},
  // {en: 'Pet name is mandatory', cs: 'Jméno mazlíčka je povinné'},
  // {en: 'Tell us how you call your pet', cs: 'Napište, jak svému psovi říkáte'},
  // {en: 'Previous', cs: 'Vrátit se zpět'},
  // {en: 'Next', cs: 'Pokračovat'},
  // {en: 'Save and quit', cs: 'Uložit a odejít'},
  // {en: 'Blank', cs: 'Nevyplněno'},
  // {en: 'Proceed to order', cs: 'Přejít k objednávce'},
  // {en: 'Proceed to order', cs: 'Zadejte věk svého psa'},
];



// WEBPACK FOOTER //
// ./src/data/translateTexts.js